const translations = {
    search: 'Search boundaries'
};

export default translations;
